<template>
  <div class="home-container">
    <div class="linear-bg"></div>
    <!-- <img class="top-img" src="../../../public/img/main-top.png" alt=""> -->
    <div class="home-scroll">
      <div class="top-div">
        <div class="banner">
          <swiper :options="bannerSwiperOption" class="banner_swiper">
            <swiper-slide v-for="(v, key) in banners" :key="key">
              <van-image class="banner_img" :src="$formatImgUrl(v.url)">
                <template v-slot:loading>
                  <van-loading type="circular" />
                </template>
              </van-image>
            </swiper-slide>

            <!-- ⭐ 分页 -->
            <div class="swiper-pagination" slot="pagination"></div>

          </swiper>
        </div>
        <div class="notice-bar">
          <img class="notice-img" src="../../../public/img/main/laba.png" alt="">
          <van-notice-bar class="notice-swipe" background="#ffffff" color="#7F677B" :text="this.notice" />
        </div>
        <!-- <div class="hot-title-div" style="margin: 0 auto;">
          <div>
            <div class="hot-img"></div>
            <span>{{ $t('index.task') }}</span>
          </div>
          <div @click="gotoMenu('/Game')">
            <div class="gmaeimg-list">
              <img class="gmae-img" src="/img/lottery/data/data1.jpg" alt="">
              <img class="gmae-img" src="/img/lottery/data/data2.jpg" alt="">
              <img class="gmae-img" src="/img/lottery/data/data3.jpg" alt="">
              <img class="gmae-img" src="/img/lottery/data/data4.jpg" alt="">
            </div>
            <span>{{ $t('index.recmonmand') }}</span>
            <van-icon name="arrow" size="25" color="#979799" />
          </div>
        </div> -->
      </div>
      <!-- <div class="chengshi">
        <img class="chengshi-img" src="../../../public/img/main/chengshi.png" alt="">
        <div class="tit">{{ $t('index.熱門城市') }}</div>
        <div class="child">
          <div class="name" :class="selectedIdx == idx ? 'active' : ''" v-for="(item, idx) in addlist"
            @click="addgo(item, idx)" :key="idx">{{ item.name }}</div>
        </div>
      </div> -->
      <!-- <div class="hot-game">
        <div class="hot-title-div">
          <div>
            <span>{{ $t('index.task') }}</span>
          </div>
          <div @click="gotoMenu('/Game')">
            <span>{{ $t('index.more') }}</span>
            <van-icon name="arrow" color="#979799" />
          </div>
        </div>
        <div class="hot-items-div">
          <van-grid :border=false :column-num="4" :icon-size="20">
            <van-grid-item @click="toLottery(v.key, v.id)" v-for="(v, key) in gameitem" :key="key">
              <van-image class="game_item_img" :src="v.ico">
                <template v-slot:loading>
                  <van-loading type="circular" />
                </template>
              </van-image>
              <span>{{ v.name }}</span>
            </van-grid-item>
          </van-grid>
        </div>
      </div> -->
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="hot-recommend">
          <div class="hot-title-div">
            <div>
              <span>{{ $t('index.hot') }}</span>
            </div>
            <div>
              <span @click="gotoMenu('/Video')">{{ $t('index.more') }}</span>
              <van-icon name="arrow" color="#979799" />
            </div>
          </div>
          <div class="movie_list_0">
            <swiper class="movie_swiper" :options="movielistSwiperOption">
              <swiper-slide v-for="(v, key) in movielist_0" :key="key">
                <van-image class="movie_cover" @click="toPlayVideo(v.id)" round :src="v.cover">
                  <template v-slot:loading>
                    <van-loading type="circular" />
                  </template>
                </van-image>
                <img class="hot" v-if="key === 0" src="/img/home/no1.png">
                <img class="hot" v-if="key === 1" src="/img/home/no2.png">
                <img class="hot" v-if="key === 2" src="/img/home/no3.png">
                <div class="movie-list-item-bottom">
                  <div class="movie-time-div">
                    <span>{{ v.title }}</span>
                    <div class="van-count-down">{{ v.time }}</div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <!-- <div class="hot-title-div">
            <div>
              <div class="hot-img"></div>
              <span>{{ $t('index.熱門美女') }}</span>
            </div>
            <div @click="gotoGengduo">
              <span>{{ $t('index.recmonmand') }}</span>
              <van-icon name="arrow" size="25" color="#979799" />
            </div>
          </div> -->
          <!-- <div class="movie_list_1">
            <div class="movie-list-item" v-for="(v, key) in datalist" :key="key" @click="profile(v.id)">
              <van-image class="cover_img1" round :src="v.img_url">
                <template v-slot:loading>
                  <van-loading type="circular" />
                </template>
              </van-image>
              <div class="movie-list-item-bottom1">
                <div class="xuanfei_name">{{ v.xuanfei_name }}</div>
              </div>
            </div>
            <div class="hot-recommend-more">{{ $t('index.想要了解更多美女請聯繫平台客服') }}</div>
          </div> -->
          <div class="hot-title-div">
            <div>
              <img class="hot-img" src="../../../public/img/main/hot.png" alt="">
              <span>{{ $t('index.more') }}</span>
            </div>
            <div @click="gotoMenu('/Video')">
              <span>{{ $t('index.recmonmand') }}</span>
              <van-icon name="arrow" size="25" color="#979799" />
            </div>
          </div>
          <div class="movie_list_1">
            <div class="movie-list-item" v-for="(v, key) in movielist_1" :key="key" @click="toPlayVideo(v.id)">
              <van-image class="cover_img" round :src="v.cover">
                <template v-slot:loading>
                  <van-loading type="circular" />
                </template>
              </van-image>
              <div class="movie-list-item-bottom">
                <div class="movie-time-div">
                  <span>{{ v.title }}</span>
                  <span>{{ $t('video.play') }}:{{ v.count }}</span>
                </div>
              </div>
            </div>
            <div class="hot-recommend-more" @click="gotoMenu('/Video')">{{ $t('index.more') }}</div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      banners: [],
      basicData: [],
      gameitem: [{}, {}, {}, {}],
      movielist_0: [{}, {}, {}, {}],
      movielist_1: [{}, {}, {}, {}, {}, {}, {}, {}],
      isLoading: false,
      movielistSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      bannerSwiperOption: {
        loop: true,
        speed: 800,

        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        slidesPerView: 1,
        effect: 'slide'
      },
      addlist: [],
      datalist: [],
      feiData: {},
      selectedIdx: 0,
    };
  },
  methods: {
    getxuanfeilist(id = 1) {
      this.$http({
        method: 'get',
        url: 'xuanfeilist',
        data: { id: id }
      }).then(res => {
        // this.datalist = res.data;
        this.datalist = res.data.slice(0, 6);
      });
    },
    addgo(data, i) {
      this.feiData = data
      this.getxuanfeilist(data.id)
      this.selectedIdx = i
      // if (!localStorage.getItem('token')) {
      //   this.$router.push({ path: '/Login' });
      // } else {
      //   this.$router.push({ path: '/list?id=' + data.id + '&name=' + data.name });
      // }
    },
    gotoGengduo() {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
      } else {
        if (this.feiData.name) {
          this.$router.push({ path: '/list?id=' + this.feiData.id + '&name=' + this.feiData.name });

        } else {
          this.$router.push({ path: '/list?id=' + this.addlist[0].id + '&name=' + this.addlist[0].name });
        }
      }
    },
    getAddress() {
      this.$http({
        method: 'get',
        url: 'address_list'
      }).then(res => {
        this.addlist = res.data;
        this.feiData = this.addlist[0]
      });
    },
    gotoMenu(router) {
      this.$router.replace(router)
    },
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
      } else {
        this.$router.push({ path: '/Lottery?key=' + key + "&id=" + id })
      }

    },
    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
      } else {
        this.$router.push({ path: '/PlayVideo?id=' + id })
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.getBasicConfig();
        this.isLoading = false;
        this.$toast("刷新成功");
      }, 500);
    },
    getBasicConfig() {
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res => {
        console.log(res, 'resres');

        this.basicData = res.data;
        this.getNotice(this.basicData);//获取公告
        this.getBanner(this.basicData);//获取banner
        // this.getGameItem();//获取首页游戏列表
        this.getMovieList_0(this.basicData);//获取首页视频0
        this.getMovieList_1(this.basicData);//获取首页视频1
      })

    },
    getNotice(data) {
      this.notice = data.notice;
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_hot'
      }).then(res => {
        this.gameitem = res.data
      })
    },
    getMovieList_0(data) {
      this.movielist_0 = data.movielist_0
    },
    getMovieList_1(data) {
      this.movielist_1 = data.movielist_1
    },
    getBanner(data) {
      this.banners = data.banners;
    },
    profile(id) {
      this.$router.push({ path: '/profile?id=' + id + '&name=' + this.feiData.name + '&adsid=' + this.feiData.id });
    },
  },
  mounted() {

  },
  created() {
    this.getBasicConfig();
    this.getAddress();
    // this.getxuanfeilist();
  }
}

</script>

<style lang='less' scoped>
@notice-bar-size: 30px;
@movie-list-item-bottom-size: 25px;

.linear-bg {
  height: 200px;
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
  border-radius: 0 0 10% 10%;
  position: relative;
  z-index: 1;
}

.home-container {
  background-color: #F2F2F4;
}

.linear-gradient {
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));
}

::v-deep .van-notice-bar__left-icon,
.van-notice-bar__right-icon {
  min-width: 40px;
}

.notice-swipe {
  width: calc(100% - 50px);
  height: 85px;
  font-size: @notice-bar-size;
}

::v-deep .van-icon-bullhorn-o::before {
  transform: scale(2.5);
}

.top-div {
  width: 100%;
  padding-bottom: 20px;
  background-color: #fff;
  margin-bottom: 20px;
}

.banner {
  width: calc(100% - 64px);
  margin: 0 32px;
  margin-top: -16%;

  .banner_swiper {
    width: 100%;
    height: 300px;
    position: relative;

    .swiper-slide {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .banner_img {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 8px;
  }

  ::v-deep .swiper-pagination {
    bottom: 12px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.6);
      margin: 0 4px;
      transition: all 0.3s ease;
    }

    .swiper-pagination-bullet-active {
      width: 20px;
      height: 6px;
      border-radius: 3px;
      background: #fff;
    }
  }
}

.notice-bar {
  width: 100%;
  margin: 4px 32px 10px;
  padding-left: 70px;
  position: relative;

  .notice-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 75px;
    height: 75px;
  }
}

.chengshi {
  width: calc(100% - 64px);
  margin: 0 32px;
  background: url('../../../public/img/main/chengshi-bg.png') no-repeat center;
  background-size: 100% 100%;
  border-radius: 8px;
  padding: 36px 24px;
  box-sizing: border-box;
  position: relative;

  .chengshi-img {
    position: absolute;
    top: 28px;
    right: 28px;
    width: 60px;
    height: 60px;
  }

  .tit {
    font-size: 32px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 36px;
  }

  .child {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    .name {
      width: calc((100% - 64px) / 5);
      font-size: 26px;
      font-weight: 500;
      color: #fff;
      min-height: 56px;
      // line-height: 56px;
      overflow-wrap: break-word;
    }

    .active {
      color: #FFFA64;
    }
  }
}

.hot-game {
  width: 100%;
  height: 100%;
}

.hot-title-div {
  width: calc(100% - 50px);
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto 24px;
}

.hot-title-div>div:first-child {
  // width: 430px;
  display: flex;
  align-items: center;
  gap: 6px;

  .hot-img {
    width: 4px;
    height: 32px;
    background-color: #795C77;
    margin-right: 10px;
  }
}

.hot-title-div div {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .gmaeimg-list {
    display: flex;
    align-items: center;
    margin-right: 12px;

    .gmae-img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-left: -20px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}

.hot-title-div>div:nth-child(2) span {
  font-size: 20px;
  color: #979799;
}

.hot-title-div>div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 32px;
  font-weight: 600;
  color: #333333;
}


.hot-title-div>div:nth-child(2) span {
  font-size: 25px;
  color: #979799;
}

// .hot-title-div>div:first-child span:before {
//   content: "";
//   display: block;
//   width: 5px;
//   height: 30px;
//   background-color: #7e5678;
//   border-radius: 1px;
//   margin-right: 5px;
// }

.hot-game .hot-items-div {
  margin-top: -3px;
}

.hot-game .hot-items-div span {
  margin-top: 10px;
  font-size: 28px;
  color: #000;
}

.hot-recommend {
  width: 100%;
  flex: 1;
}

.movie_swiper {
  .swiper-slide {
    width: 80%;
  }
}

.movie_list_0 {
  width: calc(100% - 50px);
  margin: 0 auto;
}

.movie_cover {
  border-radius: 10px;
  width: 550px;
  height: 330px
}

.movie_list_0 .movie-list-item-bottom {
  position: relative;
  width: 550px;
  bottom: 43px;
}

.movie_list_0 .movie-list-item-bottom .movie-time-div {
  background-color: rgba(0, 0, 0, .4);
}

.movie_list_0 .movie-list-item-bottom>div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie_list_0 .movie-list-item-bottom .movie-time-div .van-count-down {
  font-size: 28px;
  color: #fff;
}

.movie_list_0 .movie-time-div {
  color: #fff;
  border-radius: 0 0 10px 10px;
}

.movie_list_0 .movie_swiper .hot {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 80px;
}

.movie_list_0 span {
  font-size: 30px;
}

.movie_list_1 {
  display: flex;
  width: calc(100% - 50px);
  margin: 0 auto;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.movie_list_1 .movie-list-item .cover_img {
  border-radius: 10px;
  height: 335px;
  width: 335px;
}

.movie_list_1 .movie-list-item .cover_img1 {
  width: 335px;
  height: 450px;
  // height: auto;
  border-radius: 8px 8px 0 0;
  background-color: #fff;
  margin-bottom: -10px;

  ::v-deep .van-image__img {
    width: 100%;
    height: 100%;
    // object-fit: cover;
    object-fit: contain;
    image-rendering: auto;
  }
}

.movie_list_1 .movie-list-item .movie-list-item-bottom1 {
  width: 335px;
  padding: 20px;
  border-radius: 0 0 8px 8px;
  background-color: #fff;
  font-size: 28rpx;
  font-weight: 400;
  color: #666666;
  margin-bottom: 36px;

  .xuanfei_name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* 超过2行省略 */
    overflow: hidden;
  }
}

.top-img {
  margin-top: 20px;
  width: 100%;
  height: 110px;
}

.home-scroll {
  padding-bottom: 110px;
}

.movie_list_1 .movie-list-item {
  margin-bottom: -10px;
}

.movie_list_1 .movie-list-item-bottom {
  position: relative;
  width: 335px;
  bottom: 42px;

}

.movie_list_1 .movie-list-item:nth-child(odd) {
  margin-right: 25px;
}

.movie_list_1 .movie-list-item-bottom .movie-time-div {
  background-color: rgba(0, 0, 0, .4);
}

.movie_list_1 .movie-list-item-bottom>div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie_list_1 .movie-list-item-bottom .movie-time-div .van-count-down {
  color: #fff;
}

.movie_list_1 .movie-time-div {
  color: #fff;
  border-radius: 0 0 10px 10px;
  height: 35px;
}

.movie_list_1 .movie_swiper .hot {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 5px;
}

.movie_list_1 .movie-list-item .movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 180px;
  padding-left: 8px;
  font-size: 25px;
}

.movie_list_1 .movie-list-item .movie-time-div span:last-child {
  overflow: hidden;
  white-space: nowrap;
  width: 0px;
  padding-right: 110px;
  font-size: 22px;
}

.movie_list_0 .movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 350px;
  padding-left: 10px;
  font-size: 25px;
}

.hot-recommend-more {
  width: 100%;
  padding-bottom: 60px;
  text-align: center;
  color: #979799;
  font-size: 30px;
}

.hot-items-div .game_item_img {
  width: 100px;
  height: 100px;
}

::v-deep .hot-items-div .game_item_img .van-image__img {
  border-radius: 20px;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}
</style>